import React from 'react';

import PropTypes from 'prop-types';

import { REPORT_STATUS_CONFIG } from '../constants';

const ReportStatusIcon = ({ iconSize = 16, status }) => {
    const statusConfig = REPORT_STATUS_CONFIG[status];

    if (!statusConfig) return null;

    const isTransparent = statusConfig?.color === 'transparent';

    return (
        <statusConfig.Icon
            sx={{
                fontSize: iconSize,
                border: isTransparent ? '1px solid gray' : undefined,
                borderRadius: isTransparent ? '50%' : undefined,
                color: statusConfig.color,
            }}
        />
    );
};

ReportStatusIcon.propTypes = {
    iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ReportStatusIcon;
